// extracted by mini-css-extract-plugin
module.exports = {"declaration":"LUgoSiIr-977B7Z0Q5OL7g==","footer":"LgythdSlClkgydOq-EbBFQ=="};